var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 241.197,
    height: 48.94,
    viewBox: "0 0 241.197 48.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 241.197,
    height: 48.94,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75177",
    "data-name": "Path 75177",
    d: "M342.393,20.2l-7.269,25.9h-.482l-7.51-19.6-7.665,19.6h-.482l-7.149-25.9h2.583l5.168,18.663L326.855,20.2h.517l7.183,18.663L339.826,20.2Z",
    transform: "translate(-144.693 -9.371)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75178",
    "data-name": "Path 75178",
    d: "M385.47,51.507h-2.394V48.215A9.306,9.306,0,0,1,375.555,52a8.993,8.993,0,0,1-6.849-2.993,10.055,10.055,0,0,1-2.753-7.131,9.872,9.872,0,0,1,2.813-7.077,9.133,9.133,0,0,1,6.858-2.94,8.7,8.7,0,0,1,7.451,4.014V32.352h2.394Zm-2.239-9.472a7.794,7.794,0,0,0-2.105-5.534,6.956,6.956,0,0,0-5.3-2.248,6.873,6.873,0,0,0-6.41,3.847,7.891,7.891,0,0,0,0,7.738,7.489,7.489,0,0,0,2.724,2.863,7,7,0,0,0,3.669,1.027,7.394,7.394,0,0,0,3.746-1.018,7.052,7.052,0,0,0,2.724-2.758,8.013,8.013,0,0,0,.954-3.918",
    transform: "translate(-169.805 -14.783)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75179",
    "data-name": "Path 75179",
    d: "M408.229,20.5V45.53h2.43V18.981Z",
    transform: "translate(-189.421 -8.807)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75180",
    "data-name": "Path 75180",
    d: "M420.668,20.5V45.53h2.43V18.981Z",
    transform: "translate(-195.193 -8.807)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75181",
    "data-name": "Path 75181",
    d: "M440.307,46.358a5.421,5.421,0,0,1-1.636,4.038A5.534,5.534,0,0,1,434.64,52a6.6,6.6,0,0,1-5.529-2.712l1.516-1.761a5.218,5.218,0,0,0,3.9,2.113,3.612,3.612,0,0,0,2.415-.9A2.87,2.87,0,0,0,438,46.463a3.123,3.123,0,0,0-1.255-2.441,14.846,14.846,0,0,0-2.441-1.475,10.918,10.918,0,0,1-3.042-2.166,4.966,4.966,0,0,1-1.307-3.451,4.847,4.847,0,0,1,1.473-3.653,5.074,5.074,0,0,1,3.66-1.417q2.584,0,5.2,2.588l-1.547,1.637a5.508,5.508,0,0,0-3.764-1.9,2.914,2.914,0,0,0-1.977.753,2.389,2.389,0,0,0-.859,1.873q0,1.892,3.575,3.782a12.5,12.5,0,0,1,3.2,2.222,5,5,0,0,1,1.393,3.545",
    transform: "translate(-199.11 -14.783)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75182",
    "data-name": "Path 75182",
    d: "M103.279,38.537a7.675,7.675,0,0,1-1.06,3.921,6.822,6.822,0,0,1-2.885,2.74,10.606,10.606,0,0,1-4.806.9h-7.1V20.2H91.41a20.56,20.56,0,0,1,5.065.457,6.8,6.8,0,0,1,3.565,2.234,6.162,6.162,0,0,1-1.205,8.935,7.037,7.037,0,0,1,4.444,6.713M96.75,27.521q0-2.641-3.26-2.641H92.254v5.458H93.3q3.449,0,3.449-2.817m1.774,10.855q0-3.619-5.274-3.619h-1v6.655h1.2a9.8,9.8,0,0,0,3.349-.424,2.576,2.576,0,0,0,1.718-2.612",
    transform: "translate(-40.569 -9.371)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75183",
    "data-name": "Path 75183",
    d: "M142.111,42.4l-.017.915H127.006a5.074,5.074,0,0,0,1.788,3.271,5.519,5.519,0,0,0,3.579,1.166A6.219,6.219,0,0,0,136.9,45.89l3.957,1.9A9.615,9.615,0,0,1,132.4,52a9.584,9.584,0,0,1-9.957-9.965,10.212,10.212,0,0,1,2.731-7.262,9.128,9.128,0,0,1,6.967-2.914,9.536,9.536,0,0,1,7.2,2.887,10.342,10.342,0,0,1,2.773,7.659m-4.754-2.887a4.657,4.657,0,0,0-1.871-2.615,5.377,5.377,0,0,0-3.124-.959,5.535,5.535,0,0,0-3.434,1.116,6.212,6.212,0,0,0-1.717,2.458Z",
    transform: "translate(-56.813 -14.782)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75184",
    "data-name": "Path 75184",
    d: "M215.887,41.911a10.285,10.285,0,0,1-1.309,5.07,9.535,9.535,0,0,1-3.591,3.689A9.8,9.8,0,0,1,205.966,52a9.224,9.224,0,0,1-6.907-2.931,9.883,9.883,0,0,1-2.825-7.122,9.754,9.754,0,0,1,3.221-7.482,9.259,9.259,0,0,1,6.494-2.606,9.817,9.817,0,0,1,4.986,1.347,9.606,9.606,0,0,1,3.643,3.68,10.108,10.108,0,0,1,1.309,5.027m-4.771.018a5.749,5.749,0,0,0-1.391-3.957,5.113,5.113,0,0,0-7.416.043,5.712,5.712,0,0,0-1.373,3.914,5.807,5.807,0,0,0,1.356,3.949A4.657,4.657,0,0,0,206,47.51a4.709,4.709,0,0,0,3.725-1.632,5.759,5.759,0,0,0,1.391-3.949",
    transform: "translate(-91.053 -14.782)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75185",
    "data-name": "Path 75185",
    d: "M253.435,51.507h-4.668V43.119q0-2.62-.086-3.324a4.354,4.354,0,0,0-1.252-2.954,2.946,2.946,0,0,0-1.852-.58q-3.017,0-3.857,3.676a22.277,22.277,0,0,0-.206,3.886v7.685h-4.7V32.352h4.7v1.954a8.67,8.67,0,0,1,5.556-2.447,6.331,6.331,0,0,1,4.731,1.99,6.889,6.889,0,0,1,1.634,5Z",
    transform: "translate(-109.882 -14.783)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75186",
    "data-name": "Path 75186",
    d: "M286.432,21.921v6.569a7.943,7.943,0,0,0-5.9-2.6c-.157,0-.313,0-.463.012a7.873,7.873,0,0,0-5.989,3.069,10.113,10.113,0,0,0-.835,1.2,11.112,11.112,0,0,0-1.5,5.827,10.521,10.521,0,0,0,2.461,6.974,8.123,8.123,0,0,0,12.233.546v2.022h4.7V18.982ZM285.3,39.938a4.745,4.745,0,0,1-3.777,1.669,4.635,4.635,0,0,1-3.706-1.7,5.921,5.921,0,0,1-1.374-3.967,5.856,5.856,0,0,1,1.356-3.949,4.678,4.678,0,0,1,3.71-1.65,4.759,4.759,0,0,1,3.743,1.589,5.8,5.8,0,0,1,1.409,3.992,5.985,5.985,0,0,1-1.359,4.019",
    transform: "translate(-126.088 -8.808)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75187",
    "data-name": "Path 75187",
    d: "M179.024,32.778,165.793,62.246h-4.858l5.342-11.738-7.131-17.729h4.823L168.836,44.8,174.2,32.778Z",
    transform: "translate(-73.845 -15.209)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75188",
    "data-name": "Path 75188",
    d: "M35.276,16.88H20.109V1.558A1.55,1.55,0,0,0,18.567,0H1.543A1.55,1.55,0,0,0,0,1.558V35.636a1.55,1.55,0,0,0,1.543,1.558H35.276a1.55,1.55,0,0,0,1.543-1.558v-17.2a1.55,1.55,0,0,0-1.543-1.558M3.4,4.473A1.033,1.033,0,0,1,4.428,3.435H15.681A1.033,1.033,0,0,1,16.71,4.473V16.88H3.4ZM16.71,33.76H4.428A1.034,1.034,0,0,1,3.4,32.721V20.314H16.71Zm16.709-1.039a1.034,1.034,0,0,1-1.028,1.039H20.109V20.314H32.391a1.034,1.034,0,0,1,1.028,1.039Z",
    transform: "translate(0 0)",
    fill: "#192951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75189",
    "data-name": "Path 75189",
    d: "M56.743,0H47.954a1.2,1.2,0,0,0-.837,2.042L56.5,11.518a1.182,1.182,0,0,0,2.021-.846V1.793A1.785,1.785,0,0,0,56.743,0",
    transform: "translate(-21.701 0)",
    fill: "#41b47e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe506d7579e2f8d20d3fcb8856ca8b0c.svg";
export { ForwardRef as ReactComponent };